const siteConfig = {
  logos: [
    {
      title: 'AVROTROS',
      icon: 'eenvandaag-general:at-logo',
      url: 'https://avrotros.nl',
      target: '_blank',
    },
    {
      title: 'NPO Start',
      icon: 'eenvandaag-general:npo-logo',
      url: 'https://npo.nl/start?ns_campaign=meernpo&ns_mchannel=omroep&ns_source=avrotros&ns_linkname=button',
      target: '_blank',
    },
  ],
  footer: {
    broadcasts: [
      {
        title: 'Maandag t/m zaterdag om 18.30 uur op NPO1',
        icon: 'eenvandaag-general:npo-1-logo',
      },
      {
        title: 'Maandag t/m vrijdag van 12.00 tot 13.30 uur op NPO Radio 1',
        icon: 'eenvandaag-general:npo-radio-1-logo',
      },
    ],
  },
  socials: [
    {
      title: 'Facebook',
      url: 'https://www.facebook.com/eenvandaag',
      icon: 'eenvandaag-general:facebook',
    },
    {
      title: 'Bluesky',
      url: 'https://bsky.app/profile/eenvandaag.nl',
      icon: 'eenvandaag-general:bluesky',
    },
    {
      title: 'Redit',
      url: 'https://www.reddit.com/r/EenVandaag/',
      icon: 'eenvandaag-general:redit',
    },
    {
      title: 'Whatsapp',
      url: 'https://www.whatsapp.com/channel/0029VaFwt9w2f3ERZ01QXk1g',
      icon: 'eenvandaag-general:whatsapp',
    },
    {
      title: 'Instagram',
      url: 'https://www.instagram.com/eenvandaag',
      icon: 'eenvandaag-general:instagram',
    },
    {
      title: 'Threads',
      url: 'https://www.threads.net/@eenvandaag',
      icon: 'eenvandaag-general:threads',
    },
    {
      title: 'Youtube',
      url: 'https://www.youtube.com/user/EenVandaag',
      icon: 'eenvandaag-general:youtube',
    },
    {
      title: 'TikTok',
      url: 'https://www.tiktok.com/@eenvandaag',
      icon: 'eenvandaag-general:tiktok',
    },
  ],
};

export default siteConfig;
